import { createSelector } from 'reselect';

const getChanges = state => state.blockPageSettings.changes;
const getBlockPageSettings = state => state.blockPageSettings;

const getChangedFields = createSelector(
  [getChanges],
  changes => Object.keys(changes)
);

export { getChangedFields, getBlockPageSettings };
